export enum ERoute {
  HOME = '/',
  LINK_USER_TO_BRAND = '/usuario/logado/vincular',
  REGISTER_BRAND_CONSULTANT = '/usuario/logado/consultor',
  REGISTER_NEW_BRAND_CONSULTANT = '/consultor/marca/nova',
  REGISTER_NEW_BRAND = '/usuario/logado/marca',
  USERS = '/usuarios',
  BRAND_MANAGEMENT = '/marcas',
  EDIT_BRAND = '/marcas/edit',
  REGISTER_NEW_PARTNER_BRAND = '/marcas/partner',
  COMPLAINTS_MANAGEMENT = '/denuncias',
  CATALOG = '/catalogo',
  REASON_COMPLAINT_MANAGEMENT = '/motivos',
  EDIT_REASON_COMPLAINT = '/motivos/editar',
  REGISTER_NEW_REASON_COMPLAINT = '/motivos/criar',
  REPORTS = '/relatorios',
  FAQ = '/faq',
  ACCEPTANCE_TERM = '/termo-aceite',
  REGULATORY_AGENCY_MANAGEMENT = '/orgaos',
  REGISTER_NEW_REGULATORY_AGENCY = '/orgaos/criar',
  EDIT_REGULATORY_AGENCY = '/orgaos/editar',
  ALL_TICKETS_MANAGEMENT = '/todas/denuncias',
  SERVICE_REPORTS_MANAGEMENT = '/atendimento/denuncia',
  IMPORT_TICKETS = '/importacao/tickets',
  SUB_SPECIFICATION_MANAGEMENT = '/sub-especificacoes',
  EDIT_SUB_SPECIFICATION = '/sub-especificacoes/editar',
  REGISTER_NEW_SUB_SPECIFICATION = '/sub-especificacoes/criar',
}
